module.exports = __webpack_public_path__ + "static/media/gongshi.45c62ff0.png";